import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useCustomerStore } from '@/my/modules/account/stores/customer.store'
import { useSessionStore } from '@/stores/session'
import metaHelpers from '@/utils/meta-helpers'
import { useNotificationStore } from '@/stores/notification'
import { isNetworkOrTimeoutError } from '@/services/api/base'
import { myRoutes } from '@/my/my.routes'
import { ticketsRoutes } from '@/tickets/tickets.routes'

function getRoutes() {
  const origin = window.location.origin

  if (origin == import.meta.env.VITE_DOMAIN_MY) {
    return myRoutes
  } else {
    return ticketsRoutes
  }
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: getRoutes()
})

router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore()
  const sessionStore = useSessionStore()
  const customerStore = useCustomerStore()

  const pingResult = await sessionStore.ping()

  if (!isNetworkOrTimeoutError(pingResult.errorCode)) {
    authStore.isAuthenticated = pingResult.success

    if (authStore.isAuthenticated) await customerStore.loadFromSessionToken()
  }

  document.title = metaHelpers.getTitle((to.name || '').toString())
  next()
})

router.afterEach(() => {
  const notificationStore = useNotificationStore()
  notificationStore.clearDisplayed()
})

export default router
